import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Status } from './status';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class StatusService {

    private api_url = `${environment.ApiUrl}/status`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<Status[]>(this.api_url);
    }

    save(status: Status) {
        //return this.http.post<Status>(this.api_url, status, httpOptions);
    }

    update(status: Status) {
        //return this.http.put<Status>(this.api_url, status, httpOptions);
    }

    delete(status: Status) {
        //const url = `${this.api_url}/${status.id}`;
        //return this.http.delete(url, httpOptions);
    }
}